import React from 'react';
import { Link } from 'react-router-dom';
import { User, DollarSign, Calendar } from 'lucide-react';
import KanbanBoard from './KanbanBoard';
import { fmtCurrency } from '../utils/formatCurrency';

const STATUS_COLUMNS = [
  { key: 'Order Created', label: 'Order Created', color: 'warning' },
  { key: 'Shipped', label: 'Shipped', color: 'success' },
];

function OrdersKanban({ orders, onStatusChange, canEdit = true }) {
  const columns = STATUS_COLUMNS.map((col) => ({
    id: col.key,
    title: col.label,
    color: col.color,
    items: orders.filter((order) => order.status === col.key),
  }));

  const handleCardMove = (cardId, fromColumnId, toColumnId) => {
    onStatusChange(cardId, toColumnId);
  };

  const getColumnTotal = (items) => {
    return items.reduce((sum, order) => sum + (Number(order.total) || 0), 0);
  };

  const renderColumnHeader = (column) => (
    <>
      <div className="kanban-column-title">
        <span className="kanban-stage-name">{column.title}</span>
        <span className="kanban-stage-count">{column.items.length}</span>
      </div>
      <div className="kanban-column-total">
        ${fmtCurrency(getColumnTotal(column.items))}
      </div>
    </>
  );

  const renderCard = (order) => (
    <>
      <Link to={`/orders/${order.id}`} className="kanban-card-title">
        {order.order_number || `Order #${order.id}`}
      </Link>
      {order.account_name && (
        <Link to={`/accounts/${order.account_id}`} className="kanban-card-account">
          {order.account_name}
        </Link>
      )}
      <div className="kanban-card-details">
        <div className="kanban-card-amount">
          <DollarSign size={12} />
          ${fmtCurrency(order.total)}
        </div>
        {order.order_date && (
          <div className="kanban-card-date">
            <Calendar size={12} />
            {new Date(order.order_date).toLocaleDateString()}
          </div>
        )}
      </div>
      {order.created_by_name && (
        <div className="kanban-card-owner">
          <User size={12} />
          {order.created_by_name}
        </div>
      )}
    </>
  );

  return (
    <KanbanBoard
      columns={columns}
      onCardMove={handleCardMove}
      renderCard={renderCard}
      renderColumnHeader={renderColumnHeader}
      getItemId={(order) => order.id}
      getItemColumnId={(order) => order.status}
      canDrag={canEdit}
      emptyMessage={canEdit ? 'Drop orders here' : 'No orders'}
    />
  );
}

export default OrdersKanban;
